import {Biscuit, getAllUrlParams, Notification} from "../../../../utils";
import React, {useEffect, useState} from "react";
import {
    useSelector,
    contingentsActions,
    locationActions,
    resourcetypesActions,
    productsActions
} from "inbooma-api";
import {$, _} from "../../../../../vendor";
import moment from "moment/moment";
import t from "../../../helpers/t";
import SortNav from "../../../components/SortNav";
import NextPageBtn from "../../../components/NextPageBtn";
import Loader from "../../../components/Loader";
import ItemView from "./ItemView";
import ContingentsSidebar from './ContingentsSidebar';
import ContingentsList from './ContingentsList';
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import {getItem} from "../../../../utils/Helper";
import Paginator from "../../../components/paginator";

const ContingentsView = (props) => {
    const {
        name,
        dispatch,
        params,
        returnPath,
        rbac,
        submenuitems,
        createAccessBar
    } = props;
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const allUrlParamsClone = {...allUrlParams};
    allUrlParams?.location_name !== undefined && delete allUrlParams.location_name;
    allUrlParams?.resourcetype_name !== undefined && delete allUrlParams.resourcetype_name;
    let language = Biscuit.get('user.lang').replace('-','_');
    const [initialized,setInitialized] = useState(false);
    const [filter,setFilter] = useState({
        find: 'full',
        ...allUrlParams
    });
    const [sort,setSort] = useState({
        sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "name",
        direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "asc"
    });
    const [_key,setKey] = useState(null);
    const [temp, setTemp] = useState(getItem('contingent',true));
    const paginationLimit = 40;
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const _resourcetypes = useSelector(state => state["resourcetypes_data"].getResourcetypes);
    const _contingents = useSelector(state => state["contingents_data"].getContingents);
    const _contingent = useSelector(state => state["contingents_data"].getContingent);
    const _deleteContingent = useSelector(state => state.contingents_data.deleteContingent);
    const [add, setAdd] = useState((params !== null && params[0] === 'add'));
   // const [contingents,setContingents] = useState(_contingents?.data);
    const [contingentsPending, setContingentsPending] = useState(false);
    const [contingentPending, setContingentPending] = useState(false);
    const _locations = useSelector(state => state["locations_data"].locations);
    //const [locations,setLocations] = useState(_locations?.data);
    const [locationsPending, setLocationsPending] = useState(false);
    const [resourcetypesPending, setResourcetypesPending] = useState(false);
    const [resetFilter,setResetFilter] = useState(false);
    const _queryState = {
        timeStamp: 0,
        value: ""
    }

    function containsNumbers(str) {
        return /\d/.test(str);
    }

    const loadNextPage = (page) => {

       // if (!pagination.has_next_page) return;

        setContingentsPending(true);
        // request next page
        let fi = {};
        Object.assign(fi, filter);
        fi.sort= sort.sort;
        fi.direction = sort.direction;

        setFilter(fi);
        if(page > 1){
            searchParams.set('page', page);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            searchParams.delete('page');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            filter: {
                ...filter,
                page: page,
                limit: paginationLimit
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
    };

    useEffect(() => {
        let requestFilter = {...filter};
        requestFilter = {...requestFilter,page: pagination.current_page};
        requestFilter = {...requestFilter,limit: paginationLimit};
        requestFilter = {...requestFilter,sort: sort.sort};
        requestFilter = {...requestFilter,direction: sort.direction};
        requestFilter = {...requestFilter, ...allUrlParams};
        if(params !== null) {
            if (typeof params[1] !== 'undefined' && params[0] === 'id') {
                requestFilter = {...requestFilter, id: params[1]};
            }
            if (typeof params[1] !== 'undefined' && params[0] === "resource_id") {
                requestFilter = {...filter, resource_id: params[1]};
                let clone = {...filter};
                setFilter(clone);
                setSort({...sort, direction: 'asc'});
                requestFilter = {...requestFilter, sort: sort.sort};
                requestFilter = {...requestFilter, direction: 'asc'};
            }
            if (typeof params[1] !== 'undefined' && params[0] === "reservation_id") {
                requestFilter = {...filter, id: params[1]};
                let clone = {...filter};
                setFilter(clone);
                setSort({...sort, direction: 'asc'});
                requestFilter = {...requestFilter, sort: sort.sort};
                requestFilter = {...requestFilter, direction: 'asc'};
            }
        }
        dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setContingentsPending(true);
        if(params !== null && containsNumbers(params[0])){
            dispatch(contingentsActions.getContingent({
                token: Biscuit.get('token'),
                id: params[0],
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setContingentPending(true);
        }
        dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                'findForSelect': 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setLocationsPending(true);
        dispatch(resourcetypesActions.getResourcetypes({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setResourcetypesPending(true);
    },[]);

    useEffect(() =>{
        if(temp === null) return;
        if(typeof temp.id === 'undefined' || temp.id === null){
            dispatch(productsActions.getProductsResetData());
        }
    },[temp])

    useEffect(() =>{
        if(!contingentsPending || _contingents.success === "") return;
        setContingentsPending(false);
        if(_contingents.success === true){
            setPagination(_contingents.pagination);
        }
        if(!locationsPending && !contingentPending && !resourcetypesPending){
            setInitialized(true);
        }
    },[_contingents]);

    useEffect(() =>{
        if(!locationsPending || _locations.success === "") return;
        setLocationsPending(false);
        if(!contingentsPending && !contingentPending && !resourcetypesPending){
            setInitialized(true);
        }
    },[_locations]);

    useEffect(() =>{
        if(!contingentPending || _contingent.success === "") return;
        setContingentPending(false);
        if(!locationsPending && !contingentsPending && !resourcetypesPending){
            setInitialized(true);
        }
    },[_contingent]);
    useEffect(() =>{
        if(!contingentsPending || _deleteContingent.success === "") return;
        if(_deleteContingent.success === true) {
            dispatch(contingentsActions.getContingentsResetData());
            forceReInit();
        } else {
            showNotification('warning',null,_deleteContingent.data.message);
        }
        setContingentsPending(false);
    },[_deleteContingent]);


    useEffect(() =>{
        if(!resourcetypesPending || _resourcetypes.success === "") return;
        setResourcetypesPending(false);
        if(!contingentsPending && !contingentPending && !locationsPending){
            setInitialized(true);
        }
    },[_resourcetypes]);

    const forceReInit = () => {
        setTimeout(() => {
            dispatch(contingentsActions.getContingents({
                token: Biscuit.get('token'),
                filter: filter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }, 1000);
        setContingentsPending(true);
    };
    const filterChangedHandle = (filter,sorts = null) => {
        let requestFilter = {...filter};
        if(sorts === null){
            sorts = sort;
        } else {
            setSort(sorts);
        }
        requestFilter.sort = sorts.sort;
        requestFilter.direction = sorts.direction;
        if(typeof filter.limit !== 'undefined'){
            requestFilter.limit = filter.limit;
            if(typeof requestFilter.page !== 'undefined'){
                delete requestFilter.page;
            }
        } else {
            requestFilter.limit = paginationLimit;
            requestFilter.page = 1;
        }
        dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setContingentsPending(true);
        setFilter(filter);
    };

    const deleteContingent = (contingent) => {
        if (confirm(t('really_remove'))) {
            dispatch(contingentsActions.deleteContingent(
                {
                    token: Biscuit.get('token'),
                    id: contingent.id,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setContingentsPending(true);
        }
    }
    const onSortChangedHandle = (ev) => {

        const el = ev.currentTarget;
        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filter.limit !== 'undefined') {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }
            if(resourceId !== null){
                requestFilter = {
                    ...requestFilter,
                    resource_id: resourceId
                }
            }
            if(reservationId !== null){
                requestFilter = {
                    ...requestFilter,
                    id: reservationId
                }
            }
            props.dispatch(contingentsActions.getContingents({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setContingentsPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key){
                key["classList"].remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const searchBarHandler = (ev) => {
        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }

        const minLength = 1;
        if (query.length >= minLength) {
            // work user search only for values bigger or equal to the minimum length
            let standardFilter = {
                sort: "name",
                direction: "asc",
                page: 1,
                find: "full",
                limit: paginationLimit,
                ...allUrlParams
            };
            searchParams.delete('item');
            if(query !== '') {
                searchParams.set('q', query);
            }
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            let filterA = standardFilter;
            setResetFilter(true);
            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;

                if (diff > 700 && _queryState.value === query) {                  // no changes after the last 700 ms -> user finished input -> start request
                    filterChangedHandle({
                        ...filterA,
                        'q': query
                    });

                }
            },800);
        } else if (filter.q !== undefined) {
            // reset filter when query was active
            let clone = {...filter};
            delete clone.q;
            filterChangedHandle(clone);
        }
        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;
    };

    const showNotification = (msgType, itemId, errorMsg ='') => {

        if (msgType === 'success') {
            new Notification({
                message : t('saved_${a}',{a:t('contingent')},'capital')+' #'+ itemId,
                duration : 5000,
                type : 'success',
                closeable : true,
                icon : 'fi fi-check'
            });
        } else if (msgType === 'warning') {
            new Notification({
                message : errorMsg,
                duration : 5000,
                type : 'warning',
                closeable : true,
                icon : 'fi fi-x'
            });
        }
    };

    const tabs =[{
        name: t('name',null,'capital'),
        smallWidth: 3,
        mediumWidth: 3,
        title: t('sort_by_${a}',{a:t('name')},'capital'),
        canSort: true,
        preselected: true,
        sort: {
            direction: sort.direction,
            data_inb_val: sort.sort
        }
    },{
        name: t('location',null,'capital'),
        smallWidth: 3,
        mediumWidth: 3,
        title: t('location',null,'capital'),
        canSort: true,
        sort: {
            direction: sort.direction,
            data_inb_val: sort.sort
        }
    },{
        name: t('description',null,'capital'),
        mediumWidth: 3,
        smallWidth: 3,
        title: t('description',null,'capital'),
        canSort: false,
    }, {
        name: t('type',null,'capital'),
        smallWidth: 3,
        mediumWidth: 3,
        title: t('type',null,'capital')
    }
    ];
    const onLocationQueryHandle = (query) => {

        // start dispatch of location query
        dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setLocationsPending(true);
    };
    return (
      <>

           <ContingentsSidebar
              dispatch={dispatch}
              heading={t('contingents',null,'capital')}
              filterChangedHandle={filterChangedHandle}
              resourcetypes={_resourcetypes?.data}
              locations={_locations?.data}
              onLocationQueryHandle={onLocationQueryHandle}
              filter={filter}
              setFilter={setFilter}
              resetFilter={resetFilter}
              setResetFilter={setResetFilter}
              rbac={rbac}
              sort={sort}
              setAdd={setAdd}
              setSort={setSort}
              initialized={initialized}
              /*summary={summary}
              summaryPending={summaryPending}*/
          />
          <div id='inb-c-main' className='columns'>
              {createAccessBar &&
                  <InboomaSubmenu
                      tabs={submenuitems}
                      smallOnlyTitle={t('contingents',null,'capital')}
                      extraClasses={"sticky-top"}
                      searchbar={true}
                      searchbarPlaceholder={t('contingent_name') + ' / ' + t('resourcetype',null,'capital')}
                      searchbarHandler={searchBarHandler}
                      pagination={pagination}
                      itemsCountPerPage={paginationLimit}
                      pageRangeDisplayed={5}
                      onChange={loadNextPage}
                      initialized={initialized}
                      itemLength={_contingents.data.length}
                  />
              }

                  <SortNav
                      tabs={tabs}
                      extraClasses={"sticky-top-sortbar"}
                      listStyle="tight"
                      handler={onSortChangedHandle}/>

             {/* {initialized && !contingentsPending && _contingents.length > 0 && typeof pagination !== 'undefined' &&
                  <Paginator
                      pagination={pagination}
                      itemsCountPerPage={paginationLimit}
                      pageRangeDisplayed={5}
                      onChange={loadNextPage}
                  />}*/}
          <div className="off-canvas-wrapper">
              {_contingents?.data.length > 0 && initialized && <ContingentsList
                  contingents={_contingents.data}
                  contingent={_contingent?.data}
                  locations={_locations?.data}
                  resourcetypes={_resourcetypes?.data}
                  dispatch={dispatch}
                  filterChangedHandle={filterChangedHandle}
                  filter={filter}
                  setFilter={setFilter}
                  sort={sort}
                  setSort={setSort}
                  _key={_key}
                  setKey={setKey}
                  params={params}
                  rbac={rbac}
                  deleteContingent={deleteContingent}
              />}
              {((typeof _contingents?.data !== 'undefined' && _contingents?.data.length < 1) || typeof _contingents?.data === 'undefined') &&
                  <>
                      <div
                          id="inb-app-collection-empty"
                          className="inb-announcement"
                          style={{ minHeight: "1150px" }}
                      >
                          <div className="inb-image-box">
                              <img alt="No Data" src={"assets/img/no_data.svg"}/>
                          </div>
                          <h3>
                              { t('app_msg_collection_empty') }
                          </h3>
                          <p>
                              { t('app_msg_collection_empty_body') }
                          </p>
                      </div>
                  </>
              }
              {contingentsPending  && <Loader
                  mediumWidth={2}
                  smallWidth={4}
                  subLoaders={5}/>}
          </div>
          </div>
          {initialized && (params !== null && (add ||  containsNumbers(params[0])) && !contingentPending  && !resourcetypesPending) &&
              <ItemView
                  dispatch={dispatch}
                  contingentsActions={contingentsActions}
                  contingent={_contingent?.data}
                  language={language}
                  params={params}
                  resourcetypes={_resourcetypes?.data}
                  requestPath={returnPath}
                  showNotification={showNotification}
                  setFilter={setFilter}
                  temp={temp}
                  setTemp={setTemp}
                  filter={filter}
                  currentUrl={new URL(window.location.href)}
              />
          }

      </>
    );
}

export default ContingentsView;